import { MeshBasicMaterial, DoubleSide } from "three";
export const SPEECH_BUBBLE_INNER_COLOR = 0x8ca7c6; // 0xd9dcff;
export const SPEECH_BUBBLE_BORDER_COLOR = 0x445160; // 0x101010;
export const SPEECH_BUBBLE_OVERLAY_INNER_MATERIAL = new MeshBasicMaterial({
    color: SPEECH_BUBBLE_INNER_COLOR,
    side: DoubleSide,
    transparent: true,
    opacity: 1,
    depthTest: false,
    depthWrite: true
});
export const SPEECH_BUBBLE_ARROW_MATERIAL = new MeshBasicMaterial({
    color: SPEECH_BUBBLE_BORDER_COLOR,
    side: DoubleSide,
    transparent: true,
    opacity: 1,
    depthTest: false,
    depthWrite: true
});
export const SPEECH_BUBBLE_OVERLAY_MATERIALS = [SPEECH_BUBBLE_OVERLAY_INNER_MATERIAL, SPEECH_BUBBLE_ARROW_MATERIAL];
